module.exports = __webpack_public_path__ + "static/img/search-icon.2dfea4fe.svg";